import { pdfjs } from 'react-pdf';

export function initializePdfWorker() {
  // 使用CDN配置PDF.js worker
  pdfjs.GlobalWorkerOptions.workerSrc =
    'https://unpkg.com/pdfjs-dist@4.8.69/build/pdf.worker.min.mjs';
}
